export default __webpack_public_path__ + "static/media/iconboda.3cbe6d6e.svg";